import React from "react";
import {
  BadgeFactoryProps,
  createMicroDegreeBadge,
  createPopularBadgeFromMonarchCustomSet,
  createMonarchBadge,
} from "./badgeFactories";
import { getBadgeTypesForProduct } from "./badgeConfig";
import { BadgeByProductProps } from "../types";

type BadgeProcessor = (props: BadgeFactoryProps) => React.ReactElement | null;

export class BadgePipeline {
  private processors: BadgeProcessor[] = [];

  addProcessor(processor: BadgeProcessor): BadgePipeline {
    this.processors.push(processor);
    return this;
  }

  process(props: BadgeFactoryProps): React.ReactElement[] {
    const badges: React.ReactElement[] = [];

    for (const processor of this.processors) {
      const badge = processor(props);
      if (badge) {
        badges.push(badge);
      }
    }

    return badges;
  }
}

export const createBadgePipeline = (
  productType: string,
  badgesByProduct?: BadgeByProductProps[],
): BadgePipeline => {
  const pipeline = new BadgePipeline();

  pipeline.addProcessor(createMicroDegreeBadge);

  pipeline.addProcessor(createPopularBadgeFromMonarchCustomSet);

  const expectedBadgeTypes = getBadgeTypesForProduct(
    productType,
    badgesByProduct,
  );
  expectedBadgeTypes.forEach((badgeType) => {
    pipeline.addProcessor((props) => createMonarchBadge(badgeType, props));
  });

  return pipeline;
};
